import { useVirtualizer } from "@tanstack/react-virtual";
import { FC, useCallback } from "react";
import RiskGridRow from "./RiskGridRow";
import { leftWidth } from "./riskColumns";
import {
	EditingCell, EditorRow, LinkIndex, RiskGridHandlers, SelectionState, estimateRowHeight, lineSelectionKey, rowCheckState
} from "./riskEditorState";

const OVERSCAN = 8;

interface Props {
	scrollElement: HTMLDivElement | null;
	offset: number;
	rows: EditorRow[];
	tab: string;
	readOnly: boolean;
	selection: SelectionState;
	editing: EditingCell | null;
	handlers: RiskGridHandlers;
	linkIndex: LinkIndex;
	options: Record<string, string[]>;
}

const RiskGridBody: FC<Props> = ({ scrollElement, offset, rows, tab, readOnly, selection, editing, handlers, linkIndex,
		options }) => {
	const itemKey = useCallback((index: number) => `${tab}|${readOnly}|${rows[index].key}`, [rows, tab, readOnly]);
	const virtualizer = useVirtualizer({
		count: rows.length,
		getScrollElement: () => scrollElement,
		estimateSize: (index) => estimateRowHeight(rows[index], tab, readOnly),
		getItemKey: itemKey,
		overscan: OVERSCAN,
		scrollMargin: offset
	});
	if (!rows.length) {
		return (
			<div className="corpo">
				<div className="vazio" style={{ width: leftWidth() }}>
					{readOnly ? 'Nenhum risco alterado.' : 'Nenhum risco encontrado para os filtros aplicados.'}
				</div>
			</div>
		);
	}
	const items = virtualizer.getVirtualItems();
	const before = items.length ? items[0].start - offset : 0;
	const after = items.length ? virtualizer.getTotalSize() - (items[items.length - 1].end - offset) : 0;
	return (
		<div className="corpo">
			<div style={{ height: before }}/>
			{items.map(item => {
				const row = rows[item.index];
				return (
					<div key={String(item.key)} data-index={item.index} ref={virtualizer.measureElement}>
						<RiskGridRow
							row={row}
							tab={tab}
							readOnly={readOnly}
							checkState={rowCheckState(selection, row, tab)}
							selectedLines={lineSelectionKey(selection, row, tab)}
							editing={editing && editing.rowKey === row.key ? `${editing.lineId || ''}|${editing.columnId}` : ''}
							handlers={handlers}
							linkIndex={linkIndex}
							options={options}
						/>
					</div>
				);
			})}
			<div style={{ height: after }}/>
		</div>
	);
};

export default RiskGridBody;
